import { GetRegistrationResponse } from "@/utils/types/NPS/Stepper/GetRegistrationDetils";
import { get } from "../axiosUitils";

const baseUrl = "/nps"; // Replace with your actual API endpoint

class GetRegistrationDetailsService {
  getRegistrationDetails = async (): Promise<GetRegistrationResponse> => {
    const response = await get<GetRegistrationResponse>(
      `${baseUrl}/registration/`
    );
    return response;
  };
}

const instance = new GetRegistrationDetailsService();
export default instance;
